import { render, staticRenderFns } from "./agendamento-medicina.vue?vue&type=template&id=540c89a6"
import script from "./agendamento-medicina.vue?vue&type=script&lang=js"
export * from "./agendamento-medicina.vue?vue&type=script&lang=js"
import style0 from "./agendamento-medicina.vue?vue&type=style&index=0&id=540c89a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports